
function BeFoot() {
    return (
        <div id="befoot">
            <p>Copyright &copy; 2021 | Crafted By Abdul Sultan</p>
        </div>
    );
}

export default BeFoot;